export default __webpack_public_path__ + "static/media/TrungTinShinji.3afb0232.jpg";